import { styled } from '@mui/material';
import { Link } from 'react-router';

import { BackArrowIcon } from '@app-velocity/icons';
import { useI18n } from '@app-velocity/i18n';

const StyledBackLink = styled(Link)(({ theme }) => ({
  padding: theme.spacing(4),
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  fontWeight: 700,
  '&:link,&:visited,&:hover,&:active': {
    color: 'var(--text-text-primary-color)',
  },
  svg: {
    fill: 'var(--button-primary-icon-icon-color)',
  },
}));

export const BackLink = () => {
  const { t } = useI18n();

  return (
    <StyledBackLink to="/">
      <BackArrowIcon /> {t('prototypes:all_reports.title')}
    </StyledBackLink>
  );
};
